module.exports = __webpack_public_path__ + "img/icon_2_15.a83b6bfd.png";